<template>
  <div class="internal-bady" :dir="isHebrew ? 'rtl' : 'ltr'">
    <WhatsappChet />
    <NavBar />
    <div id="top"></div>

    <div class="px-3 px-md-4" id="welcome-section">
      <div
        :style="mainHomeImageStyle"
        :class="['container-fluid', 'bg-welcome', 'rounded-5', 'd-flex', 'align-items-center', isEnglish ? 'bg-welcome-mirrored' : '']"
      >
        <div class="container">
          <div class="row position-index">
            <div class="col col-lg-8 col-xl-6 d-flex flex-column gap-3 gap-md-5">
              <h1 class="text-center text-welcome text-white mb-0">
                {{ t("welcomeRideHeroTitle") }}
              </h1>
              <p class="text-center text-white hero-subtitle fw-semibold mb-0">
                {{ t("welcomeRideHeroSubtitle") }}
              </p>
              <div class="justify-content-space-around d-flex gap-2 gap-md-3">
                <button
                  type="button"
                  class="btn btn-primary hero-cta-btn rounded-pill border border-white fw-semibold"
                  @click="goToCreateRoute"
                >
                  {{ t("welcomeRideHeroCta") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 py-md-5" id="how-it-works">
      <div class="container">
        <h2 class="text-center fw-bold black margin-for-h2 how-it-works-title">{{ t("welcomeRideHowItWorksTitle") }}</h2>
        <div class="row justify-content-center align-items-stretch">
          <div class="col-sm-6 col-lg-4 mb-2 mb-md-0 d-flex">
            <div class="card border-0 rounded-5 shadow-sm p-md-2 w-100 d-flex flex-column">
              <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center flex-grow-1">
                <div class="step-number-badge d-flex align-items-center justify-content-center mx-auto">1</div>
                <h4 class="fw-bold mb-3 black step-card-title">{{ t("welcomeRideStep1Title") }}</h4>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep1Line1") }}
                </p>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep1Line2") }}
                </p>
                <p class="step-card-text mb-0 text-muted">
                  {{ t("welcomeRideStep1Line3") }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mb-2 mb-md-0 d-flex">
            <div class="card border-0 rounded-5 shadow-sm p-md-2 w-100 d-flex flex-column">
              <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center flex-grow-1">
                <div class="step-number-badge d-flex align-items-center justify-content-center mx-auto">2</div>
                <h4 class="fw-bold mb-3 black step-card-title">{{ t("welcomeRideStep2Title") }}</h4>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep2Line1") }}
                </p>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep2Line2") }}
                </p>
                <p class="step-card-text mb-0 text-muted">
                  {{ t("welcomeRideStep2Line3") }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4 mb-2 mb-md-0 d-flex">
            <div class="card border-0 rounded-5 shadow-sm p-md-2 w-100 d-flex flex-column">
              <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center flex-grow-1">
                <div class="step-number-badge d-flex align-items-center justify-content-center mx-auto">3</div>
                <h4 class="fw-bold mb-3 black step-card-title">{{ t("welcomeRideStep3Title") }}</h4>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep3Line1") }}
                </p>
                <p class="step-card-text mb-3 text-muted">
                  {{ t("welcomeRideStep3Line2") }}
                </p>
                <p class="step-card-text mb-0 text-muted">
                  {{ t("welcomeRideStep3Line3") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="example-route">
      <div class="container-fluid py-5 bg-light-blue">
        <div class="container">
          <h2 class="text-center fw-bold black margin-for-h2 example-route-title">{{ t("welcomeRideExampleTitle") }}</h2>
          <p class="text-muted text-center example-route-intro mb-3">
            {{ t("welcomeRideExampleIntro") }}
          </p>
          <p class="text-muted text-center example-route-subtitle mb-2">
            {{ t("welcomeRideExampleSubtitle") }}
          </p>
          <p class="text-center mb-3">
            <a :href="exampleRouteUrl" target="_blank" rel="noopener noreferrer" class="text-primary example-route-link">
              {{ exampleRouteUrl }}
            </a>
          </p>
          <div class="d-flex justify-content-center">
<a
            :href="exampleRouteUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-primary example-route-btn fw-semibold"
          >
            {{ t("welcomeRideExampleBtn") }}
          </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid position-relative overflow-hidden" id="who-is-it-for">
      <div>
        <img
          alt=""
          class="background-image"
          src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba"
        >
      </div>
      <div class="container py-5">
        <h2 class="text-center fw-bold py-5 audience-section-title">{{ t("welcomeRideAudienceTitle") }}</h2>
        <div class="row justify-content-center mb-4 audience-pills-row">
          <div class="col-6 col-md-3">
            <div class="audience-pill">
              <i class="fa-solid fa-route audience-pill-icon"></i>
              <span>{{ t("welcomeRideAudiencePill1") }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="audience-pill">
              <i class="fa-solid fa-person-walking audience-pill-icon"></i>
              <span>{{ t("welcomeRideAudiencePill2") }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="audience-pill">
              <i class="fa-solid fa-plane audience-pill-icon"></i>
              <span>{{ t("welcomeRideAudiencePill3") }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="audience-pill">
              <i class="fa-solid fa-pen-fancy audience-pill-icon"></i>
              <span>{{ t("welcomeRideAudiencePill4") }}</span>
            </div>
          </div>
        </div>
        <p class="audience-tagline text-center mb-0">
          {{ t("welcomeRideAudienceTagline") }}
        </p>
      </div>
    </div>

    <div class="container-fluid py-5 bg-light-blue" id="why-tripplanner">
      <div class="container">
        <h2 class="text-center fw-bold py-5 why-title">{{ t("welcomeRideWhyTitle") }}</h2>
        <div class="row align-items-stretch py-4 g-4 g-md-5">
          <div class="col-md-6 mb-4">
            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <i class="fa-solid fa-mobile-screen benefit-icon"></i>
              </div>
              <p class="benefit-text mb-0">{{ t("welcomeRideBenefit1") }}</p>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <i class="fa-solid fa-pen-to-square benefit-icon"></i>
              </div>
              <p class="benefit-text mb-0">{{ t("welcomeRideBenefit2") }}</p>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <i class="fa-solid fa-file-pdf benefit-icon"></i>
              </div>
              <p class="benefit-text mb-0">{{ t("welcomeRideBenefit3") }}</p>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="benefit-card">
              <div class="benefit-icon-wrap">
                <i class="fa-solid fa-lock benefit-icon"></i>
              </div>
              <p class="benefit-text mb-0">{{ t("welcomeRideBenefit4") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid position-relative overflow-hidden" id="pricing">
      <div>
        <img
          alt=""
          class="background-image"
          src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba"
        >
      </div>
      <div class="container py-5">
        <div class="d-flex justify-content-center">
          <div class="w-75 full-width">
            <p class="text-muted text-center pricing-text mb-3">
              {{ t("welcomeRidePricingText") }}
            </p>
            <p class="text-center mb-4">
              <router-link to="/pricing" class="text-primary welcome-payment-link">
                {{ t("welcomeRidePricingLink") }}
              </router-link>
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-center pb-5">
          <button
            type="button"
            class="btn btn-primary pricing-btn fw-semibold"
            @click="goToCreateRoute"
          >
            {{ t("welcomeRidePricingCta") }}
          </button>
        </div>
      </div>
    </div>

    <PageFooterNew />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import PageFooterNew from "@/components/PageFooterNew.vue";
import WhatsappChet from "@/components/WhatsappChet";
import { mapGetters } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "NewUserWelcome",
  mixins: [translationMixin],
  components: {
    NavBar,
    PageFooterNew,
    WhatsappChet,
  },
  data() {
    return {
      exampleRouteUrl: "https://tripplanner.co.il/single_ride_with_map/6095",
      mainHomeImageStyle: {
        "--home-bg-image": "url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fwelcome-trip.jpg?alt=media&token=0454fe77-65ec-4ece-8c99-6d978d2a7bbd')",
      },
    };
  },
  computed: {
    ...mapGetters(["isMobile"]),
  },
  methods: {
    goToCreateRoute() {
      this.$router.push("/start-insert-ride");
    },
  },
  created() {
    if (this.isMobile) {
      const resizedUrl = "https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fhome_page_image_mobile_1.jpg?alt=media&token=72aaafda-25e5-471f-9bc2-44508cf0c568";
      this.mainHomeImageStyle = { "--home-bg-image": `url('${resizedUrl}')` };
    }
    const ref = this.$route.query.ref;
    if (ref) sessionStorage.setItem('affiliate_referrer_id', ref);
  },
};
</script>

<style scoped>
.internal-bady {
  line-height: 1.5;
}

#welcome-section {
  padding-top: 98px;
  padding-bottom: 24px;
  min-height: 100dvh;
}

.text-welcome {
  font-size: 72px;
  font-weight: 800;
}

.hero-subtitle {
  font-size: 2.4rem !important;
}

.hero-cta-btn {
  padding: 16px 40px;
  font-size: 2rem !important;
  border-width: 1px !important;
}

.bg-welcome {
  position: relative;
  overflow: hidden;
  min-height: calc(100dvh - 98px - 24px);
}

.bg-welcome::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--home-bg-image);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 32px;
  transform: scaleX(1);
  transform-origin: center;
  z-index: 0;
}

.bg-welcome::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 32px;
  background: linear-gradient(45deg, rgba(20, 20, 20, 0.4), rgba(15, 15, 15, 0.85));
  z-index: 1;
}

.bg-welcome-mirrored::before {
  transform: scaleX(-1);
}

.position-index {
  position: relative;
  z-index: 2;
}

.rounded-5 {
  border-radius: 32px !important;
}

.gap-3 {
  gap: 1.6rem !important;
}

.gap-2 {
  gap: 0.8rem !important;
}

.margin-for-h2 {
  margin-bottom: 0.8rem !important;
}

.how-it-works-title {
  font-size: calc(2.6rem + 1.5vw) !important;
}

.example-route-title {
  font-size: calc(2.6rem + 1.5vw) !important;
}

.example-route-intro {
  font-size: 1.8rem !important;
  margin-bottom: 1rem;
  line-height: 1.7;
}

.example-route-subtitle {
  font-size: 1.6rem !important;
  line-height: 1.6;
}

.example-route-link {
  font-size: 1.6rem !important;
}

.example-route-btn {
  padding: 16px 40px;
  font-size: 2rem !important;
  border-radius: 14px !important;
}

.pricing-text {
  font-size: 2rem !important;
  line-height: 1.7;
}

.welcome-payment-link {
  font-size: 1.8rem !important;
  font-weight: 600;
  text-decoration: none;
}

.welcome-payment-link:hover {
  text-decoration: underline;
}

.pricing-btn {
  padding: 18px 48px;
  font-size: 2.2rem !important;
  border-radius: 14px !important;
}

.justify-content-space-around {
  justify-content: space-around;
  padding-bottom: 15px;
}

.black {
  color: #1e1e1e;
}

.text-secondary {
  color: #0D2F29 !important;
}

.bg-light-blue {
  background-color: #E6F5F9 !important;
}

.background-image {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
}

.what_can_be_done_explanation {
  color: rgba(33, 37, 41, 0.75) !important;
  font-size: 1.6rem !important;
  margin-bottom: 1.6rem;
  line-height: 1.7;
}

.audience-section-title {
  font-size: calc(2.6rem + 1.5vw) !important;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent !important;
}

/* BS4 has no g-* row gutters; row-gap separates wrapped pill rows on narrow screens */
.audience-pills-row {
  row-gap: 1rem;
}

@media (min-width: 768px) {
  .audience-pills-row {
    row-gap: 1.5rem;
  }
}

.audience-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  padding: 1.8rem 1rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(7, 160, 195, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e1e1e;
  text-align: center;
  min-height: 100px;
  line-height: 1.5;
}

.audience-pill:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(7, 160, 195, 0.2);
}

.audience-pill-icon {
  font-size: 2.2rem;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.audience-tagline {
  font-size: 1.8rem;
  font-weight: 500;
  color: rgba(33, 37, 41, 0.85);
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.8;
}

.why-title {
  font-size: calc(2.6rem + 1.5vw) !important;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent !important;
}

.benefit-card {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding: 2rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(7, 160, 195, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
}

.benefit-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(7, 160, 195, 0.18);
}

.benefit-icon-wrap {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(52, 208, 182, 0.2), rgba(7, 160, 195, 0.2));
  display: flex;
  align-items: center;
  justify-content: center;
}

.benefit-icon {
  font-size: 1.8rem;
  background: linear-gradient(135deg, #34D0B6, #07A0C3);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.benefit-text {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1e1e1e;
  line-height: 1.7;
}

.step-number-badge {
  height: 54px;
  width: 54px;
  color: #DD6E42;
  font-weight: 900;
  font-size: 2rem;
  background-color: rgba(221, 110, 66, 0.25);
  border-radius: 50%;
}

.step-card-title {
  font-size: 2.2rem !important;
  line-height: 1.3;
}

.step-card-text {
  font-size: 1.5rem !important;
  line-height: 1.6;
  color: rgba(33, 37, 41, 0.85) !important;
}

.btn-primary {
  background: linear-gradient(45deg, #34D0B6, #07A0C3);
  color: white;
  border: 0;
}

.btn-primary:hover {
  background: linear-gradient(45deg, #39e1c5, #08add3);
  color: white;
  border: 0;
}

.text-primary {
  background-image: linear-gradient(45deg, #34D0B6, #07A0C3) !important;
  color: transparent !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
}

.full-width {
  width: 100% !important;
}

@media (min-width: 768px) {
  .gap-md-5 {
    gap: 5rem !important;
  }
  .px-md-4 {
    padding-right: 2.4rem !important;
    padding-left: 2.4rem !important;
  }
  .py-md-5 {
    padding-top: 4.8rem !important;
    padding-bottom: 4.8rem !important;
  }
}

/* Short laptop / small-height viewports: must follow .gap-md-5 rule above */
@media (max-height: 880px) and (min-width: 576px) {
  .text-welcome {
    font-size: clamp(2rem, 4.5vw, 3.25rem);
  }

  .hero-subtitle {
    font-size: 1.85rem !important;
    line-height: 1.35;
  }

  .hero-cta-btn {
    font-size: 1.55rem !important;
    padding: 12px 28px;
  }
}

@media (max-height: 880px) and (min-width: 768px) {
  .gap-md-5 {
    gap: 2.25rem !important;
  }
}

@media (max-height: 720px) and (min-width: 576px) {
  .text-welcome {
    font-size: clamp(1.75rem, 3.8vw, 2.75rem);
  }

  .hero-subtitle {
    font-size: 1.5rem !important;
    line-height: 1.35;
  }

  .hero-cta-btn {
    font-size: 1.4rem !important;
    padding: 10px 22px;
  }
}

@media (max-height: 720px) and (min-width: 768px) {
  .gap-md-5 {
    gap: 1.5rem !important;
  }
}

@media (max-width: 575.98px) {
  .text-welcome {
    font-size: 32px;
    font-weight: 800;
  }

  .hero-subtitle {
    font-size: 1.8rem !important;
  }

  .hero-cta-btn {
    padding: 14px 28px;
    font-size: 1.6rem !important;
  }

  #welcome-section {
    padding-top: 74px;
    padding-bottom: 16px;
    min-height: 100dvh;
  }

  .bg-welcome {
    min-height: calc(100dvh - 74px - 16px);
  }

  .full-width {
    width: 100% !important;
  }

  .step-number-badge {
    height: 42px;
    width: 42px;
    font-size: 1.6rem;
  }
}
</style>
